/**
 * 页面级通用样式
 */

import { createStyles } from 'antd-style';

/**
 * 创建列表页/详情页通用样式
 *
 * @example
 * ```tsx
 * const usePageStyles = createPageStyles();
 *
 * function UserListPage() {
 *   const { styles } = usePageStyles();
 *   return (
 *     <div className={styles.listPage}>
 *       <div className={styles.listHeader}>
 *         <h2>用户列表</h2>
 *         <Button type="primary">新增</Button>
 *       </div>
 *       <ProTable />
 *     </div>
 *   );
 * }
 * ```
 */
export function createPageStyles() {
  return createStyles(({ token, css }) => ({
    /** 列表页 */
    listPage: css`
      display: flex;
      flex-direction: column;
      gap: ${token.marginMD}px;
    `,

    /** 列表页头部 */
    listHeader: css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: ${token.marginSM}px;
    `,

    /** 详情页 */
    detailPage: css`
      display: flex;
      flex-direction: column;
      gap: ${token.marginLG}px;
    `,

    /** 详情页头部 (带返回按钮) */
    detailPageHeader: css`
      display: flex;
      align-items: center;
      gap: ${token.marginMD}px;
      padding-bottom: ${token.paddingMD}px;
      border-bottom: 1px solid ${token.colorBorderSecondary};
    `,

    /** 详情内容区域 */
    detailContent: css`
      background: ${token.colorBgContainer};
      border-radius: ${token.borderRadiusLG}px;
      padding: ${token.paddingLG}px;
    `,

    /** 表单页 */
    formPage: css`
      max-width: 960px;
      margin: 0 auto;
      padding: ${token.paddingLG}px;
    `,

    /** 表单区块 */
    formSection: css`
      margin-bottom: ${token.marginLG}px;

      .section-title {
        font-size: ${token.fontSizeLG}px;
        font-weight: ${token.fontWeightStrong};
        color: ${token.colorTextHeading};
        margin-bottom: ${token.marginMD}px;
        padding-bottom: ${token.paddingSM}px;
        border-bottom: 1px solid ${token.colorBorderSecondary};
      }
    `,

    /** 表单底部操作栏 */
    formFooter: css`
      display: flex;
      justify-content: center;
      gap: ${token.marginMD}px;
      padding-top: ${token.paddingLG}px;
      border-top: 1px solid ${token.colorBorderSecondary};
    `,

    /** 标签页内容区 */
    tabContent: css`
      padding-top: ${token.paddingMD}px;
    `,

    /** 描述列表区域 */
    descriptionSection: css`
      margin-bottom: ${token.marginLG}px;

      .ant-descriptions-header {
        margin-bottom: ${token.marginSM}px;
      }
    `,
  }));
}
